import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FiProfileSizes } from '@fi-shared/profile-icon/profile-icon.component';
import { ILightWeightUser, ILightWeightUserWithUnits } from '@fi-shared/models';

@Component({
    selector: 'fi-chat-conversation-users-list-item',
    template: `
        <div
          class="fi-chat-conversation-users-list-item-container"
          [ngClass]="{ 'fi-chat-conversation-user-disabled': disabled }"
          matRipple
          [matRippleDisabled]="!isRippleEffect || disabled"
          (click)="userCardClick()"
          >
          <div class="fi-chat-conversation-users-list-item-avatar-container">
            <fi-profile-icon [profileData]="user" [size]="profilePictureSize.Size32px" [isRound]="true">
            </fi-profile-icon>
          </div>
          <div class="fi-chat-conversation-users-list-item-name-container">
            <p class="fi-chat-conversation-users-list-item-name">{{ user.FullName }}</p>
            <p class="fi-chat-conversation-users-list-item-name business-unit-name">
              {{ user.PreferredBusinessUnitName }}
            </p>
          </div>
          @if (isCheckmarkShown(user)) {
            <div class="fi-chat-conversation-users-list-item-checkmark-container">
              <span class="fi-more-menu-item-checked okCcmIcon ContrastColorBefore"></span>
            </div>
          }
        </div>
        @if (isTooltipAvailable && disabled) {
          <fi-info-icon
            tooltipClass="fi-rounded-white-tooltip"
            [isIconTooltipShown]="false"
            [fiInfoPosition]="'right-under'"
            [isMaxSize]="true"
            class="inline-absolute"
            >
            {{ getTooltipText() }}
          </fi-info-icon>
        }
        `,
    styleUrls: ['./fi-chat-conversation-users-list-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-chat-conversation-users-list-item' },
    standalone: false,
})
export class FiChatConversationUsersListItemComponent {
    @Input() user: ILightWeightUserWithUnits | ILightWeightUser;
    @Input() selectedUsers: ILightWeightUserWithUnits[] | ILightWeightUser[] = [];
    @Input() isRippleEffect: boolean;
    @Input() disabled = false;
    @Input() isTooltipAvailable = false;
    @Input() tooltipText: string | ((userId: number) => string);
    @Output() onUserCardClick = new EventEmitter<ILightWeightUserWithUnits | ILightWeightUser>();
    profilePictureSize = FiProfileSizes;

    getTooltipText(): string {
        if (typeof this.tooltipText === 'function') return this.tooltipText(this.user.Id);

        return this.tooltipText;
    }

    userCardClick() {
        if (this.disabled) return;
        this.onUserCardClick.emit(this.user);
    }

    isCheckmarkShown(user: ILightWeightUserWithUnits | ILightWeightUser) {
        return this.selectedUsers.findIndex((selectedUser) => user.Id === selectedUser.Id) !== -1;
    }
}
